import React, { FC } from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { FiltersContext } from '../../reducer/filters';
import { analytics } from '../../config/firebase';
import { logEvent } from 'firebase/analytics';
import { useFilterTracking } from '../../utils/hooks/useFilterTracking';
import { useNavigate } from 'react-router-dom';

const AppGlobalSearch: FC = () => {
	const navigate = useNavigate();

	const [value, setValue] = React.useState('');

	const { setContextFilter } = React.useContext(FiltersContext);

	const { filterTracking } = useFilterTracking();

	const handleSubmit = (event: React.FormEvent<HTMLDivElement>) => {
		event.preventDefault();

		setContextFilter('searchText', value);

		if (value) {
			filterTracking('globalSearch', value);
		}

		logEvent(analytics, 'search', {
			search_term: value,
		});

		navigate('/search');
	};

	return (
		<Box
			data-cy="global-search"
			component="form"
			onSubmit={handleSubmit}
			sx={{
				color: 'text.secondary',
				border: 1,
				borderColor: 'divider',
				borderRadius: 1,
				backgroundColor: 'background.paper',
				paddingTop: '2px',
				paddingLeft: '5px',
				paddingRight: '2px',
				'&:hover': {
					backgroundColor: 'background.paper',
				},
				width: 1,
			}}
		>
			<InputBase
				value={value}
				sx={{
					marginLeft: 1,
					flex: 1,
					width: 'calc(100% - 47px)',
				}}
				name="global-search"
				onChange={(event) => setValue(event.target.value)}
				placeholder="Search anything"
				inputProps={{ 'aria-label': 'search any company or content' }}
			/>
			<IconButton
				type="submit"
				sx={{
					padding: '7px',
				}}
				aria-label="search"
			>
				<SearchIcon />
			</IconButton>
		</Box>
	);
};

export default AppGlobalSearch;
